import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import BaseModal from "../BaseModal/BaseModal";

type LoadingModalProps = {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
};

const LoadingModal = ({ open, onClose, title = "Hang tight!", message }: LoadingModalProps) => {
  const theme = useTheme();
  return (
    <BaseModal open={open} onClose={onClose} showCloseButton={false}>
      <Box
        padding={theme.spacing(12)}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress size={40} />
        <Typography variant="h2" fontWeight="bold" mt={2}>
          {title}
        </Typography>
        {message && (
          <Typography variant="modalBody" mt={1}>
            {message}
          </Typography>
        )}
      </Box>
    </BaseModal>
  );
};

export default LoadingModal;
